import { Model } from '@nozbe/watermelondb'
import { field, date, readonly, relation, children } from '@nozbe/watermelondb/decorators'

export default class Store extends Model {
    static table = 'stores'
    static associations = {
        merchants: { type: 'belongs_to', key: 'merchant_id' },
        invoices: { type: 'has_many', foreignKey: 'store_id' },
        products: { type: 'has_many', foreignKey: 'store_id' },
        customers: { type: 'has_many', foreignKey: 'store_id' },
        settings: { type: 'has_many', foreignKey: 'store_id' },
        user_invitations: { type: 'has_many', foreignKey: 'store_id' },
        billing_sessions: { type: 'has_many', foreignKey: 'store_id' },
    } as const

    @field('merchant_id') merchantId!: string
    @field('name') name!: string
    @field('address') address!: string | null
    @field('city') city!: string | null
    @field('state') state!: string | null
    @field('pincode') pincode!: string | null
    @field('phone') phone!: string | null
    @field('currency') currency!: string
    @field('gstin_override') gstinOverride!: string | null
    @field('upi_id') upiId!: string | null
    @field('invoice_prefix') invoicePrefix!: string | null
    @field('next_invoice_no') nextInvoiceNo!: number
    @field('status') status!: string
    @field('require_day_open') requireDayOpen!: boolean
    @field('emergency_bill_roles') emergencyBillRoles!: string | null
    @field('is_active') isActive!: boolean
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date

    @relation('merchants', 'merchant_id') merchant: any
    @children('invoices') invoices: any
    @children('products') products: any
    @children('customers') customers: any
    @children('user_invitations') invitations: any
    @children('billing_sessions') billingSessions: any
}
